import "spectrum-colorpicker";
import "./Base";

// fix tinycolor prototype
tinycolor.prototype.constructor = tinycolor;

/** @namespace UI.Plugin */
NS("UI.Plugin");

/**
 * @class
 * @extends UI.Plugin.Base
 */
UI.Plugin.Colorpicker = Class(UI.Plugin.Base, /** @lends UI.Plugin.Colorpicker.prototype */ {
    /**
     * @type {tinycolor}
     */
    color: undefined,
    showAlpha: true,
    showInitial: true,
    draggable: false,
    showButtons: true,
    preferredFormat: "rgb",
    allowEmpty: true,
    /**
     * @inheritDoc
     */
    initialize()
    {
        this.ParentCall();

        this.element.$element.spectrum(
            _.pick(this, ['color', 'showAlpha', 'showInitial', 'draggable', 'showButtons', 'preferredFormat', 'allowEmpty'])
        ).on("change.spectrum",
            /**
             * @param {$.Event} evt
             * @param {tinycolor} color
             */
            (evt, color) => {
                this.emit("select", { color });
            });
    },
    /**
     * @returns {UI.Plugin.Colorpicker}
     */
    destroy()
    {
        this.element.$element.spectrum("destroy");

        return this.ParentCall();
    },
    /**
     * @returns {UI.Plugin.Colorpicker}
     */
    show()
    {
        this.element.$element.spectrum("show");

        return this;
    },
    /**
     * @returns {UI.Plugin.Colorpicker}
     */
    hide()
    {
        this.element.$element.spectrum("hide");

        return this;
    },
    /**
     * @param {tinycolor} color
     * @returns {UI.Plugin.Colorpicker}
     */
    setColor(color)
    {
        this.element.$element.spectrum("set", createColor(color));

        return this;
    },
    /**
     * @returns {*}
     */
    getColor()
    {
        return this.element.$element.spectrum("get");
    },
    /**
     * @param {tinycolor} color
     * @param {string} format
     * @public
     * @static
     */
    convertColor: convertColor,
    /**
     * @param {string|Array|Object} color
     * @param {string} format
     * @returns {tinycolor}
     * @public
     * @static
     */
    createColor: createColor
});

UI.Plugin.Colorpicker.Static( /** @lends UI.Plugin.Colorpicker */ {
    /**
     * @param {tinycolor} color
     * @param {string} format
     * @public
     * @static
     */
    convertColor: convertColor,
    /**
     * @param {string|Array|Object} color
     * @param {string} format
     * @returns {tinycolor}
     * @public
     * @static
     */
    createColor: createColor
});

/**
 * @param {tinycolor} color
 * @param {string} format
 * @public
 * @static
 */
function convertColor(color, format)
{
    switch (format) {
        case "rgbstring":
            return color.toRgbString();
        case "rgbarray":
            return _.values(color.toRgb());
        case "rgb":
        default:
            return color.toRgb();
    }
}

/**
 * @param {string|Array|Object} color
 * @returns {tinycolor}
 * @public
 * @static
 */
function createColor(color)
{
    if (color == null) {
        return;
    }

    if (color instanceof tinycolor) {
        return color;
    }

    if (_.isArray(color)) {
        color = `rgb${color.length === 4 ? "a" : ""}(${color.join(",")})`;
    }

    return new tinycolor(color);
}
